import {
  getDate,
  getDay,
  isAfter,
  isEqual,
  isToday,
  startOfDay,
} from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type Props = {
  data: any;
};

const MOLAttendanceCalendar = ({ data }: Props) => {
  const studentPresentData = data?.filter((el: any) => el?.isPresent === "P");
  const presentDates = studentPresentData?.map(
    (el: any) => new Date(el?.updatedAt)
  );

  const renderDayContents = (day: any, date: any) => {
    const isWeekend = getDay(date) === 0 || getDay(date) === 6;
    const isPresent =
      presentDates?.findIndex((d: any) => {
        return isEqual(startOfDay(d), startOfDay(date));
      }) > -1;

    return (
      <div
        onClick={(e) => e.stopPropagation()}
        className={`h-full p-1 border-2 rounded pointer-events-none flex flex-col justify-between  ${
          isToday(date) && " border-sky-400"
        } ${
          isWeekend
            ? "bg-gray-100"
            : isPresent
            ? "bg-green-200"
            : isAfter(date, new Date())
            ? "bg-white"
            : "bg-red-200"
        }  `}
      >
        <div className="flex justify-start">
          <div className="text-sm font-semibold text-slate-700">
            {getDate(date)}
          </div>
        </div>

        {/* <div className="flex justify-end">
          <div className="flex items-center justify-center px-2 font-semibold bg-yellow-200 rounded text-slate-700 ">
            3 of 10
          </div>
        </div> */}
      </div>
    );
  };
  return (
    <div className="w-full h-full calendar-cmp">
      <DatePicker
        onChange={() => {}}
        inline
        calendarClassName="border border-red-400 w-full h-full flex flex-col"
        readOnly
        renderDayContents={renderDayContents}
        disabled
        calendarStartDay={1}
        showPreviousMonths={false}
      />
    </div>
  );
};

export default MOLAttendanceCalendar;
